<script setup>
import BrandHeader from "./Partials/BrandHeader.vue";
import BrandFooter from "./Partials/BrandFooter.vue";

defineProps({
    title: String,
});
</script>

<template>
    <div class="brand min-h-screen bg-brand-cream font-brand text-brand-navy">
        <BrandHeader />
        <main>
            <slot />
        </main>
        <BrandFooter />
    </div>
</template>
